<template>
  <div class="index" @click="h5show = false">
    <div class="two-big-title">Visa Application</div>
    <div class="index-con">
      <div class="bottom_span"></div>
      <div class="my-title">
        <div class="circle"></div>
        Visa Application
      </div>
      <div class="text">
        If you require an invitation letter for your visa application, you can
        download the provided
        <a
          href="https://www.fifs-isnff-2024.cn/public/uploads/VisaTemplate.docx"
          class="text-blue"
          target="_blank"
          >template</a
        >, fill it with your personal details, and then send it through Email to
        fifs@jiangnan.edu.cn. The final version of the invitation letter will be
        prepared as soon as possible.
        <br />
      </div>
      <div class="bottom_span"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped lang="less">
.index {
  .bottom_span {
    height: 2px;
    background: #28d6ec;
    width: 100%;
    margin-bottom: 100px;
    margin-top: 60px;
  }

  .lists {
    .text {
      font-size: 14px;
      margin-bottom: 40px;
      margin-top: 20px;
      font-weight: 500;
      line-height: 1.8;
    }

    .list {
      margin-top: 20px;
      width: 100%;
    }

    .name {
      font-weight: 600;
      text-align: center;
      margin-bottom: 5px;
    }

    .pic {
      width: 140px;
      display: block;
      margin: 0 auto 10px;
    }
  }

  .index-con {
    max-width: 1200px;
    margin: 0 auto;
  }

  .my-title {
    color: #28d6ec;
    font-size: 18px;
    margin: 40px 0;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
    background: #28d6ec;
  }

  .text {
    color: #333;

    line-height: 2;
    padding-bottom: 20px;
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px 14px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/hotel.vue